// Modal Manager - Système unifié de gestion des modales
class ModalManager {
  constructor() {
    this.activeModals = new Set();
    this.overlayZIndex = 10000000;
    this.modalZIndex = 10000001;
    this.init();
  }

  init() {
    // ModalManager initialized
  }

  // Créer un overlay unique pour une modal
  createOverlay(modalId) {
    // Supprimer l'overlay existant pour cette modal
    this.removeOverlay(modalId);
    
    const overlay = document.createElement('div');
    overlay.className = 'custom-modal-overlay';
    overlay.setAttribute('data-modal-id', modalId);
    overlay.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-color: rgba(0, 0, 0, 0.8) !important;
      z-index: ${this.overlayZIndex} !important;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    `;
    
    document.body.appendChild(overlay);
    return overlay;
  }

  // Supprimer l'overlay d'une modal
  removeOverlay(modalId) {
    const existingOverlay = document.querySelector(`[data-modal-id="${modalId}"]`);
    if (existingOverlay) {
      existingOverlay.remove();
    }
  }

  // Ouvrir une modal
  open(modalId, options = {}) {
    const modal = document.getElementById(modalId);
    if (!modal) {
      return;
    }

    // Créer l'overlay
    const overlay = this.createOverlay(modalId);
    
    // Configurer la modal
    modal.style.cssText = `
      display: block !important;
      visibility: visible !important;
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      z-index: ${this.modalZIndex} !important;
      background: white !important;
      border-radius: 8px !important;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3) !important;
      padding: 0 !important;
      min-width: 400px !important;
      max-width: 500px !important;
      width: auto !important;
      height: auto !important;
      max-height: 90vh !important;
      overflow: hidden !important;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    `;

    // Ajouter les classes
    modal.classList.add('custom-modal-active');
    modal.classList.remove('hidden');

    // Afficher l'overlay
    overlay.style.display = 'block';
    setTimeout(() => {
      overlay.style.opacity = '1';
    }, 10);

    // Afficher la modal
    setTimeout(() => {
      modal.style.opacity = '1';
    }, 50);

    // Ajouter à la liste des modales actives
    this.activeModals.add(modalId);

    // Gestionnaire de clic sur l'overlay
    overlay.addEventListener('click', () => {
      this.close(modalId);
    });

    // Gestionnaire de clic sur le bouton de fermeture
    const closeButton = modal.querySelector('.close.icon, .close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.close(modalId);
      });
    }
  }

  // Fermer une modal
  close(modalId) {
    const modal = document.getElementById(modalId);
    const overlay = document.querySelector(`[data-modal-id="${modalId}"]`);
    
    if (!modal) {
      return;
    }

    // Animation de disparition
    if (overlay) {
      overlay.style.opacity = '0';
    }
    modal.style.opacity = '0';

    // Fermer complètement après la transition
    setTimeout(() => {
      modal.classList.remove('custom-modal-active');
      modal.classList.add('hidden');
      modal.style.display = 'none';
      modal.style.visibility = 'hidden';
      
      if (overlay) {
        overlay.remove();
      }

      // Retirer de la liste des modales actives
      this.activeModals.delete(modalId);
    }, 300);
  }

  // Fermer toutes les modales
  closeAll() {
    this.activeModals.forEach(modalId => {
      this.close(modalId);
    });
  }

  // Vérifier si une modal est ouverte
  isOpen(modalId) {
    return this.activeModals.has(modalId);
  }

  // Obtenir la liste des modales actives
  getActiveModals() {
    return Array.from(this.activeModals);
  }
}

// Instance globale
window.modalManager = new ModalManager();

// Export pour les modules
export default window.modalManager;
